(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-wholesale-fast"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 760px)');

    const resetMobilePagePosition = () => {
      if (!mobileQuery.matches) return;

      const target = document.querySelector('.rv-wholesale-fast .rvw-pricing');
      if (target && window.location.hash === `#${target.id}`) {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
      }

      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'auto' }));
      });
    };

    const initWholesaleScroll = (scope = document) => {
      scope.querySelectorAll('.rv-wholesale-fast').forEach((root) => {
        const trigger = root.querySelector('[data-rvw-prices-trigger]');
        const target = root.querySelector('.rvw-pricing');

        if (!trigger || !target || trigger.dataset.rvwScrollReady === 'true') return;
        trigger.dataset.rvwScrollReady = 'true';

        trigger.addEventListener('click', (event) => {
          if (!mobileQuery.matches) return;

          event.preventDefault();
          const header = document.querySelector('header');
          const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
          const targetTop = window.scrollY + target.getBoundingClientRect().top;

          window.scrollTo({
            top: Math.max(0, targetTop - headerHeight - 12),
            behavior: 'smooth'
          });
        });

const mobileQuery = window.matchMedia('(max-width: 760px)');

    const resetMobilePagePosition = () => {
      if (!mobileQuery.matches) return;

      const target = document.querySelector('.rv-wholesale-fast .rvw-pricing');
      if (target && window.location.hash === `#${target.id}`) {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
      }

      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'auto' }));
      });
    };
      });
    };

    resetMobilePagePosition();
    window.addEventListener('pageshow', resetMobilePagePosition);
    initWholesaleScroll();
    document.addEventListener('shopify:section:load', (event) => initWholesaleScroll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
